export default __webpack_public_path__ + "media/zurb/img/about/bryan/bryan-img3-a48cbbc6395ea9679ef6855c5f179754.png";